import { CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { Plus } from 'lucide-react';
import { useRef } from 'react';

import IconButton from '@/components/Button/IconButton';
import Input from '@/components/Inputs/Input';
import Typo from '@/components/Typography/Typo';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const LinksField = (props: { required?: boolean }) => {
  const { required = false } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="flex-1 flex flex-col gap-2">
      {/* Hidden form field for actual data storage */}
      <Form.Item name={SCRAPER_REQ_FIELD_KEY.LINKS} hidden>
        <input />
      </Form.Item>

      {/* Visual label and input */}
      <Form.Item
        label="Links"
        required={required}
        shouldUpdate={(prevValues, currentValues) =>
          prevValues[SCRAPER_REQ_FIELD_KEY.LINKS] !==
          currentValues[SCRAPER_REQ_FIELD_KEY.LINKS]
        }
      >
        {({ getFieldValue, setFieldValue }) => {
          const currentLinks: string[] = getFieldValue('links') || [];
          const hasError = required && currentLinks.length === 0;

          return (
            <div className="flex-1 flex flex-col gap-1">
              <div className="flex gap-2">
                <Input
                  ref={inputRef}
                  sizeType="m"
                  placeholder="Type product link"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      e.stopPropagation();
                      const newLink = e.currentTarget.value.trim();
                      if (newLink) {
                        setFieldValue('links', [...currentLinks, newLink]);
                        e.currentTarget.value = '';
                      }
                    }
                  }}
                />
                <IconButton
                  sizeType="m"
                  icon={<Plus size={14} />}
                  onClick={() => {
                    if (!inputRef.current) return;
                    setFieldValue('links', [
                      ...currentLinks,
                      inputRef.current?.value,
                    ]);
                    inputRef.current.value = '';
                  }}
                />
              </div>
              {currentLinks.length > 0 && (
                <div className="w-full flex flex-col gap-2 pt-2">
                  {currentLinks.map((link, index) => (
                    <div key={`${link}-${index}`} className="flex">
                      <Typo
                        className="flex-1 break-all w-[360px]"
                        type="label2"
                        ellipsis
                      >
                        {link}
                      </Typo>
                      <CloseOutlined
                        onClick={() => {
                          setFieldValue(
                            'links',
                            currentLinks.filter((_, i) => i !== index),
                          );
                        }}
                        className="cursor-pointer"
                      />
                    </div>
                  ))}
                </div>
              )}
              {hasError && (
                <div className="text-destructive text-xs">
                  Links is required
                </div>
              )}
            </div>
          );
        }}
      </Form.Item>
    </div>
  );
};
